import { Grid, Switch } from "@mui/material";
import { VerticalDivider } from "components/alove/VerticalDivider";
import { useMaterialUIController } from "context";
import { BoUser, NotifcationSetting } from "models/BO/BoUser";
import { useState, useEffect } from "react";
import { updateUserDO } from "utils/systemUsersUtils";
const MDTypography = require("components/MDTypography/index.js").default;



export const SUNotificationsSettings = ({boUser}:{boUser: BoUser}) => {
  const [controller] = useMaterialUIController();
  const { mobileView } = controller;

  const [notification, setNotification] = useState<NotifcationSetting>({Email: true, WA: true, SMS: true});

  useEffect(() => {
    setNotification(boUser.notifications || {Email: true, WA: true, SMS: true} as NotifcationSetting);
  }, [boUser.notifications]);

  const updateNotification = (key: string, value: boolean) => {
    updateUserDO({id: boUser.id, notifications: {...notification, [key]: value}});
    setNotification({...notification, [key]: value});
  }

  return (
    <Grid container alignItems="center" style={{width:mobileView ? "70%" : "100%"}} justifyContent={"space-between"}>
      <Switch checked={notification.Email} onChange={() => updateNotification("Email", !notification.Email)} />
      <MDTypography variant="body2">Email Notification</MDTypography>
      <VerticalDivider />
      <Switch checked={notification.WA} onChange={() => updateNotification("WA", !notification.WA)} />
      <MDTypography variant="body2">WhatsApp Notification</MDTypography>
      <VerticalDivider />
      <Switch checked={notification.SMS} onChange={() => updateNotification("SMS", !notification.SMS)} />
      <MDTypography variant="body2">SMS Notification</MDTypography>
    </Grid>
  );
};
